import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import About from "@/pages/home/components/About";
import Services from "@/pages/home/components/Services";
import WhyUs from "@/pages/home/components/WhyUs";
import Process from "@/pages/home/components/Process";
import Contact from "@/pages/home/components/Contact";
import Footer from "@/pages/home/components/Footer";
import SeoScript from "@/pages/home/components/SeoScript";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-100">
      <SeoScript />
      <Navbar />
      <Hero />
      <About />
      <Services />
      <WhyUs />
      <Process />
      <Contact />
      <Footer />
    </main>
  );
}